<template>
  <div class="contentCenter">
    <LoadingSpinner v-if="loading || loadingOptionsClaims" />
    <div class="row mt-4 p-4" v-if="!loading && !loadingOptionsClaims">
      <h4 for="firstname" class="font-weight-bolder">
        {{ $t("lang.refuse.title") }}
      </h4>
      <p class="my-2">{{ $t("lang.refuse.desc") }}</p>
      <div class="col-12">
        <p class="text-left mt-3 mb-2">
          {{ $t("lang.label.complaint_form_q1") }}
          <small><i class="icon-asterisk text-danger ml-1"></i></small>
        </p>
        <select v-model="why" class="form-control mb-3">
          <option
            v-for="claim in claimOptions"
            :key="claim.id"
            :value="claim.id"
          >
            {{ $t(`lang.menu.${claim.title}`) }}
          </option>
        </select>
        <div v-if="!isIncorrectOptionSelected && why != '' && why != null">
          <p class="text-left mt-3 mb-2">
            {{ $t("lang.refuse.details_label") }}
            <small><i class="icon-asterisk text-danger ml-1"></i></small>
          </p>
          <textarea
            id="claim_details"
            class="form-control text-color"
            rows="3"
            :maxlength="detailsMaxLength"
            v-model="details"
            :placeholder="$t('lang.refuse.details_placeholder')"
            required="true"
          >
          </textarea>
          <div class="d-flex justify-content-between mb-3">
            <small class="text-muted">
              {{ $t("lang.refuse.details_min_length", { min: detailsMinLength }) }}
            </small>
            <small class="text-muted">
              {{ details.length }}/{{ detailsMaxLength }}
            </small>
          </div>

          <strong class="ml-2">{{ $t("lang.refuse.sentemail") }}:</strong>
          <div class="col-12 pl-0 my-2">
            <div class="mb-4" v-if="sendemailplease">
              <div class="input-group my-2">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default"
                    >From:</span
                  >
                </div>
                <input
                  disabled
                  :value="$t('lang.label.client_team_you_badge')"
                  id="input_response"
                  type="text"
                  class="form-control input-a"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                />
              </div>
              <div class="input-group my-2">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default"
                    >To:</span
                  >
                </div>
                <input
                  disabled
                  :value="
                    opportunity.link.event.invitees[0].name +
                    ' <' +
                    opportunity.link.event.invitees[0].email +
                    '>'
                  "
                  id="input_response"
                  type="text"
                  class="form-control input-a"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                />
              </div>
              <textarea
                type="text"
                class="form-control mb-2 text-color"
                id="subject"
                v-model="reply_email.subject"
                rows="1"
                v-bind:placeholder="$t('lang.label.subjectCanceled')"
                required="true"
              >
              </textarea>
  
              <textarea
                type="text"
                class="form-control text-color"
                id="email"
                v-model="reply_email.message"
                rows="10"
                v-bind:placeholder="
                  $t('lang.label.hello') +
                  ' ' +
                  opportunity.link.event.invitees[0].name +
                  `\n` +
                  $t('lang.label.refuseopportunitybody')
                "
                required="true"
              >
              </textarea>
            </div>
            <div>
              <h6>
                <small><i class="icon-asterisk text-danger mr-1"></i></small
                >{{ $t("lang.refuse.conditions") }}
              </h6>
              <input
                class="d-inline mr-2 mt-2 cursor-pointer"
                type="checkbox"
                v-model="oliverexplaination"
              />
              {{ $t("lang.refuse.checkbox") }}
            </div>
            <Tooltip
              class=""
              :text="disabledRefuse ? $t('lang.refuse.please_complete') : null"
              :width="'auto'"
            >
              <button
                :disabled="disabledRefuse"
                @click="refuse()"
                class="btn btn-sm btn-danger mt-2"
              >
                {{ $t("lang.refuse.button") }}
              </button>
            </Tooltip>
            <button class="btn btn-sm btn-primary mt-2 ml-2" @click="cancel()">
              {{ $t("lang.button.cancel") }}
            </button>
          </div>
        </div>
        <div v-else>
          <div v-if="why != '' && why != null" class="alert alert-warning mt-3 p-3" style="border-left: 4px solid #ffc107;">
            <p class="text-left mb-2 font-weight-bold" style="font-size: 0.9rem;">
              Disclaimer:
            </p>
            <p class="text-left mb-0" style="font-size: 0.85rem;">
              {{ incorrectOptionMessage }}
            </p>
          </div>
          <button class="btn btn-sm btn-primary mt-2 ml-2" @click="cancel()">
            {{ $t("lang.button.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { opportunitiesService, emailsService, adminService } from "@/_services";
import Tooltip from "@/components/Common/Tooltip.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  components: { Tooltip, LoadingSpinner },
  data() {
    return {
      emailanswer: "",
      loadingOptionsClaims: false,
      claimOptions: [],
      oliverexplaination: "",
      loading: true,
      sendemailplease: true,
      why: "",
      details: "",
      detailsMinLength: 20,
      detailsMaxLength: 200,
      reply_email: {
        to: "",
        subject: "",
        message: "",
        email_selected: {
          id: null,
          link_id: null,
          response_to: null,
        },
      },
    };
  },

  computed: {
    ...mapState({
      opportunity: (state) => state.opportunities.selected.data,
    }),
    isDetailsValid() {
      return this.details.trim().length >= this.detailsMinLength;
    },
    disabledRefuse() {
      return (
        !this.isDetailsValid ||
        (this.sendemailplease &&
          (!this.reply_email.to ||
            this.reply_email.to == "" ||
            !this.reply_email.subject ||
            this.reply_email.subject == "" ||
            !this.reply_email.message ||
            this.reply_email.message == "" ||
            !this.oliverexplaination ||
            !this.why))
      );
    },
    isIncorrectOptionSelected() {
      return (
        this.why &&
        typeof this.why === "string" &&
        this.why.startsWith("Incorrect_")
      );
    },
    incorrectOptionMessage() {
      if (!this.isIncorrectOptionSelected) return null;
      const messageKey = `lang.label.incorrect_option_${this.why.replace('Incorrect_', '')}`;
      return this.$t(messageKey);
    },
  },

  watch: {
    why() {
      this.details = "";
    },
  },

  created() {
    this.getOptionsClaim();
    this.reply_email.to = this.opportunity.link.event.invitees[0].email;
    this.loading = false;
    this.reply_email.label_from = this.opportunity.link.owner_name;
    this.reply_email.email_selected.link_id = this.opportunity.link.id;
  },

  methods: {
    getOptionsClaim() {
      this.loadingOptionsClaims = true;
      adminService
        .getAllOptionsClaims()
        .then((response) => {
          this.claimOptions = response;
          this.addIncorrectOptionsClaim();
        })
        .catch((error) => {
          console.error("Error fetching options claims:", error);
          this.loadingOptionsClaims = false;
        })
        .finally(() => {
          this.loadingOptionsClaims = false;
        });
    },

    addIncorrectOptionsClaim() {
      const fakeOptions = [
        {
          id: "Incorrect_1",
          title: "prospect_no_need_not_interested",
          is_active: "1",
        },
        {
          id: "Incorrect_2",
          title: "prospect_refuses_meeting_says_no_by_email",
          is_active: "1",
        },
        { id: "Incorrect_3", title: "forced_abusive_meeting", is_active: "1" },
        {
          id: "Incorrect_4",
          title: "prospect_not_decision_maker_wrong_level",
          is_active: "1",
        },
        {
          id: "Incorrect_5",
          title: "prospect_is_consultant_freelance",
          is_active: "1",
        },
        { id: "Incorrect_6", title: "direct_competition", is_active: "1" },
        {
          id: "Incorrect_7",
          title: "already_in_contact_parent_group_entity",
          is_active: "1",
        },
        {
          id: "Incorrect_8",
          title: "account_is_already_client",
          is_active: "1",
        },
        {
          id: "Incorrect_9",
          title: "incomplete_info_atypical_email",
          is_active: "1",
        },
        {
          id: "Incorrect_10",
          title: "different_company_size_societe_pappers",
          is_active: "1",
        },
        { id: "Incorrect_11", title: "absence_no_show", is_active: "1" },
      ];
      this.claimOptions = [...this.claimOptions, ...fakeOptions];
    },

    cancel() {
      this.$emit("cancel");
    },
    refuse() {
      this.sendEmail();
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getEvent() {},
    getSelectedClaimOption() {
      return this.claimOptions.find(
        (claim) => String(claim.id) === String(this.why)
      );
    },
    getSelectedClaimReasonText() {
      const claim = this.getSelectedClaimOption();
      if (!claim) {
        return "";
      }
      return this.$t(`lang.menu.${claim.title}`);
    },
    sendEmail() {
      if (
        this.reply_email.to == "" ||
        this.reply_email.subject == "" ||
        this.reply_email.message == "" ||
        this.why == "" ||
        this.why == null ||
        !this.isDetailsValid
      ) {
        return;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.refuse.title"),
        text: this.$t("lang.refuse.reportValidity"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.send"),
      }).then((result) => {
        if (result.value) {
          const claimReasonId = this.why;
          const claimDetails = this.details.trim();
          const reasonText = this.getSelectedClaimReasonText();
          const message =
            this.$t("lang.refuse.refusewarning") + ": " + reasonText;

          opportunitiesService.refuse(this.opportunity.link.id, message);

          if (this.sendemailplease) {
            this.startLoadingSendEmail = true;
            if (
              !this.reply_email.to.includes("*") &&
              !this.reply_email.to.includes("(")
            ) {
              if (!this.validEmail(this.reply_email.to)) {
                this.errors.push("The email field is invalid.");
                this.startLoadingSendEmail = false;
                return false;
              }
            }
            emailsService
              .replyEmail(this.reply_email, this.file)
              .then((res) => {
                this.startLoadingSendEmail = false;
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  text: this.$t("lang.label.emailwassentsuccessfully"),
                  showConfirmButton: false,
                  timer: 1500,
                });
              })
              .then((res) => {
                let date_ob = new Date();
                let date = ("0" + date_ob.getDate()).slice(-2);
                let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
                let year = date_ob.getFullYear();

                var newEmail = {
                  id: "newEmail",
                  name: this.reply_email.label_from,
                  link: this.reply_email.subject,
                  comment: this.reply_email.message,
                  type: "emailsentopportunity",
                  response_from: this.reply_email.to,
                  creation_date: year + "-" + month + "-" + date,
                };
              })
              .catch((error) => {
                this.startLoadingSendEmail = false;
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  text:
                    error && error.error
                      ? error.error
                      : this.$t("lang.label.error"),
                  showConfirmButton: true,
                });
              });
          }

          this.$emit("refused", claimReasonId, claimDetails);
        }
      });
    },
  },
};
</script>
<style scoped>
.text-color {
  color: #aeaeae;
}
</style>
